
export default {

    treatmentPlan: 'Plan de tratamiento ',
    lastFollow: 'Último seguimiento',
    newFollow: 'Nuevo seguimiento',
    closeDate: 'Fecha de cierre',
    assetImpact: 'Activo / Impacto',
    riskId: 'ID de riesgo',
    controlId: 'ID de control',
}